import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { handleResponse } from '../../ApiServices/ApiHandler';
import { t } from 'i18next';
import {
  createShippingMethods,
  getShippingMethodsByPage
} from '../../ApiServices/ShippingMethodsServices';

export const initialState = {
  value: { totalCount: -1, data: [] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  message: null
};

const shippingMethodsSlice = createSlice({
  name: 'shippingMethods',
  initialState: initialState,
  reducers: {
    clearShippingMethodsState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.message = null;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchShippingMethods.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
    });
    builder.addCase(fetchShippingMethods.rejected, (state: any, action: any) => {
      state.loading = initialState.loading;
      state.error = action?.payload?.data;
    });
  }
});

export const shippingMethodsState = (state: RootState) => state?.shippingMethods;
export const { clearShippingMethodsState } = shippingMethodsSlice.actions;
export default shippingMethodsSlice.reducer;

export const fetchShippingMethods = createAsyncThunk(
  'shippingMethods/fetchShippingMethods',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_SHIPPING_METHODS') }));
      return fulfillWithValue(await getShippingMethodsByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const addShippingMethod = createAsyncThunk(
  'shippingMethods/addShippingMethod',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('ADDING_NEW_SHIPPING_METHOD') }));
      let response = await createShippingMethods(payload);
      return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
